import { EarthBoxPlusIcon } from './EarthBoxPlusIcon';

/**
 * author: Muhammet Balsoy
 * id 5CEC6008-A993-410B-985A-4E41291BE614
 * name earth-box-plus
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-box-plus.svg
 * tags
 * - Navigation 
 */
export const WorldBoxPlusIcon = EarthBoxPlusIcon;
export default WorldBoxPlusIcon